module.exports = __webpack_public_path__ + "static/media/borrowerWhite.9f8d097e.svg";